<template>
  <div class="desktop-only">
    <NavPage v-if="!isMapFullscreen" />
    <HeaderPage v-if="!isMapFullscreen" />
  </div>
  <div class="mobile-only">
    <!-- <MobileHeader v-if="!isMapFullscreen && isMobile" /> -->
    <MobileHeader
      v-if="!isMapFullscreen && isMobile"
      :accepted-order="acceptedOrderDetails"
    />
    <div class="profile-page"></div>
    <div class="container-fluid py-5">
      <!-- Top Menu -->
      <div class="row text-center g-3 mb-4">
        <div class="col-6 col-md-3 col-lg-6">
          <router-link to="/order_list">
            <div class="p-3 border rounded shadow-sm bg-white hover-effect">
              <i class="ri-file-list-line fs-3 text-danger"></i>
              <div class="mt-2 fw-bold text-dark">{{ $t("orders") }}</div>
            </div>
          </router-link>
        </div>

        <div class="col-6 col-md-3 col-lg-6">
          <router-link to="/account_edit">
            <div class="p-3 border rounded shadow-sm bg-white hover-effect">
              <i class="ri-user-settings-line fs-3 text-danger"></i>
              <div class="mt-2 fw-bold text-dark">{{ $t("profile edit") }}</div>
            </div>
          </router-link>
        </div>
      </div>

      <!-- Bottom Menu -->
      <div class="row text-center g-3">
        <div class="col-12">
          <router-link to="/help_center">
            <div class="p-3 border rounded shadow-sm bg-white hover-effect">
              <i class="ri-question-line fs-4 text-secondary"></i>
              <span class="ms-2 fw-bold text-dark">{{ $t("help center") }}</span>
            </div>
          </router-link>
        </div>
        <div class="col-12">
          <a @click="handleLogout">
            <div class="p-3 border rounded shadow-sm bg-white hover-effect text-danger">
              <i class="ri-logout-box-r-line fs-4"></i>
              <span class="ms-2 fw-bold">{{ $t("logout") }}</span>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
  <FooterBarPage></FooterBarPage>
</template>

<script setup>
import MobileHeader from "../header/MobileHeader.vue";
import FooterBarPage from "../layout/FooterBarPage.vue";
import { LOCAL_STORAGE_KEYS } from "@/utils/constants";
import axios from "axios";
import { useRouter } from "vue-router";
import HeaderPage from "../header/HeaderPage.vue";
import NavPage from "../navigation/NavPage.vue";

const router = useRouter();

const handleLogout = async () => {
  try {
    localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN_KEY);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH_USER_INFO);
    delete axios.defaults.headers.common["Authorization"];

    // Redirect to login page using path instead of name
    router.push("/"); // Changed from { name: '/' } to just '/'
  } catch (error) {
    console.error("Logout error:", error);
    localStorage.removeItem(LOCAL_STORAGE_KEYS.AUTH_TOKEN_KEY);
    delete axios.defaults.headers.common["Authorization"];
    router.push("/"); // Changed here as well
  }
};
// No JS needed
</script>

<style scoped>
.hover-effect {
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.hover-effect:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.profile-page {
  background-color: #f8f9fa;
  /* min-height: 100vh; */
  /* padding-top: 80px; */
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  border-radius: 30px;
  /* လှပတဲ့ round ပုံစံ */
  /* padding: 30px; */
  margin-top: -20px;
  /* Header နဲ့ ပေါင်းသွားအောင် */
  z-index: 1;
  position: relative;
}
</style>
